module.exports = __webpack_public_path__ + "assets/images/restaurant-01.5e798a440b7512c3752887d196890455.svg";